import { Component, OnInit } from '@angular/core';
import { UserProfileService } from '../../core/http/user-profile.service';
import { DatePipe } from '@angular/common';
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';
import { AlertDialogComponent, ConfirmDialogModel } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DateAdapter } from '@angular/material/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators
} from '@angular/forms';
import * as moment from 'moment';

@Component({
    selector: 'app-add-notifications',
    templateUrl: './add-notifications.component.html',
    styleUrls: ['./add-notifications.component.scss'],
    standalone: false
})

export class AddNotificationsComponent implements OnInit {
  createNotification: UntypedFormGroup;
  url: any;
  modules = {};
  editorStyle = {
    width: '100%',
    height: '150px'
  };
  files:any= [];
  minDate: any;
  fileName: any=[];
  formatedDate: any;
  urls = [];
  selectImageValue: any;
  isEdit = false;
  editNotificationId: 0;
  deletedFiles = [];
  editnotification;
  showLoader: boolean = false;
  constructor(private formBuilder: UntypedFormBuilder, private userProfileService: UserProfileService,
    private datePipe: DatePipe, private ds: DataService, public dialog: MatDialog, private router: Router,
    private dateAdapter: DateAdapter<Date>, private route: ActivatedRoute) {
    this.modules = {
      toolbar: [
        ['bold', 'italic', 'underline', { 'color': [] },'link'],        // toggled buttons
      ]
    };
    this.dateAdapter.setLocale('en-GB'); // dd/MM/yyyy

  }

  ngOnInit(): void {
    this.minDate = new Date();
    this.createForm();

    this.route.queryParams.subscribe(res => {
      if (res && res.notificationId) {
        this.ds.getService(environment.BASEURL + '/notifications?id=' + res.notificationId)
          .subscribe(notifications => {
            this.editNotificationId = res.notificationId;
            if (notifications && notifications.length > 0) {
              this.editnotification = notifications[0];
              this.editnotification.issueDate = new Date( moment.utc(this.editnotification.publishDateTime).local().format('L LT'));

              this.editnotification.issuedTime = this.editnotification.issueDate.getHours() + ':' + this.editnotification.issueDate.getMinutes();
              this.createNotification.setValue({
                summaryNotification: this.editnotification.summary, description: this.editnotification.discription,
                issueDate: this.editnotification.issueDate, issuedTime: this.editnotification.issuedTime,
                uploadImage: null,
              });
              this.createNotification.updateValueAndValidity();
              if (this.editnotification.smthFiles && this.editnotification.smthFiles.length > 0) {
                this.editnotification.smthFiles.forEach(fileData => {
                  this.urls.push(fileData.filePath);
                });
              }
              this.isEdit = true;
            }
          });

      }
    });
  }
  createForm() {
    this.createNotification = this.formBuilder.group({
      summaryNotification: ['', [Validators.required,],],
      description: ['', [],],
      issueDate: ['', [Validators.required,],],
      issuedTime: ['', [Validators.required,],],
      uploadImage: ['', [],],

    });
  }

  onFileSelected(event) {
    

    if (event.target.files && event.target.files[0]) {
      const filesAmount = event.target.files.length;
      for (let i = 0; i < filesAmount; i++) {
        this.files.push(event.target.files[i].name);
       this.fileName.push(event.target.files[i]);
        const reader = new FileReader();
        reader.readAsDataURL(event.target.files[i]);
        reader.onload = (event) => {

          const obj = {
            obj:
              reader.result
          };
          console.log(typeof obj);
          this.urls.push(event.target.result);
          this.createNotification.patchValue({
            document: event.target.result
          });
        };

      }
    }
  }

  alertDialog(dialogData) {
    this.dialog.open(AlertDialogComponent, {
      height: '250px',
      width: '600px',
      data: dialogData
    });
  }

  strip_html_tags(str)
{
   if ((str===null) || (str===''))
       return false;
  else
   str = str.toString();
  return str.replace(/<[^>]*>/g, '');
}

  saveNotification(option) {
    this.showLoader = true;
    const formatedpublishDateTime = new Date(this.datePipe.transform(this.createNotification.controls.issueDate.value, 'yyyy-MM-dd'));
    const publishTime = this.createNotification.controls.issuedTime.value;
    formatedpublishDateTime.setHours(publishTime.split(':')[0]);
    formatedpublishDateTime.setMinutes(publishTime.split(':')[1]);
    if(new Date(moment.utc().add(15,'m').local().format('L LT')) > formatedpublishDateTime){
      const dialogData_er = new ConfirmDialogModel('Alert', 'Notification not saved please check date and time', 'simpleconfirm');
      this.showLoader = false;
      this.alertDialog(dialogData_er);
      return false;             
    }
    const SmthNotification = {
      SmthNotification: {

        Id: this.isEdit ? this.editNotificationId : 0,
        Summary: this.createNotification.controls.summaryNotification.value,
        Discription: this.strip_html_tags(this.createNotification.controls.description.value),
        PublishDateTime: formatedpublishDateTime,
        ModifiedBy: this.userProfileService.currentUserObject.id,
        IsActive: true,

      },
      SmthFiles: [],
      SmthDeleteFiles: []
    };

    if (this.files) {
      this.files.forEach(x => {
        SmthNotification.SmthFiles.push({FileName: x})
      });
     console.log( SmthNotification.SmthFiles)
      // SmthNotification.SmthFiles = [
      //   {
      //     FileName: this.files
      //   }
      // ];
    }

    if (this.deletedFiles && this.deletedFiles.length > 0) {
      this.deletedFiles.forEach(deletedFile => {
        SmthNotification.SmthDeleteFiles.push({
          id: deletedFile.id,
          name: deletedFile.fileName
        });
      });
    }

    let formData = new FormData();
      this.fileName.forEach(y => {
        formData.append('formFiles', y);
      });
      
    const notificationdata = btoa(JSON.stringify(SmthNotification));
    formData.append("SmthNotification",notificationdata)  
    const dialogData = new ConfirmDialogModel('Alert', 'Notification saved successfully', 'simpleconfirm');
    this.ds.createService(environment.BASEURL + '/Notification', formData).subscribe(res => {
      this.showLoader = false;
      this.alertDialog(dialogData);
      this.router.navigate(['/notification']);
    }, (error) =>{
      this.showLoader = false;
    });
    console.log(formData)

  }

  currentPeriodClicked(event) {
    if (event.value.toDateString() === new Date().toDateString()) {
      const publishTime = this.createNotification.controls.issuedTime.value;
      const currentDate = new Date();
      if (publishTime) {
        if (publishTime.split(':')[0] < currentDate.getHours() || publishTime.split(':')[1] < currentDate.getMinutes()) {
          this.createNotification.controls.issuedTime.setValue('');
        }
      }
    }
  }
  deleteImage(i) {
    this.selectImageValue=i;
    if (this.selectImageValue > -1) {
      this.urls.splice(this.selectImageValue, 1);
      if (this.isEdit && this.editnotification.smthFiles.length > this.selectImageValue) {
        const deletedFile = this.editnotification.smthFiles[this.selectImageValue]
        this.deletedFiles.push(deletedFile);
      }else{
        this.files.splice(i,1)
      }
    } else {
      this.urls.splice(i, 1);
    }
  }
  selectImage(index) {
    this.selectImageValue = index;
  }

  reset() {
    this.createNotification.reset();
    this.router.navigate(['notification']);
  }


  getMinTime() {
    const date = new Date();
    if (this.createNotification.controls.issueDate.value) {
      if (new Date(this.createNotification.controls.issueDate.value) > date) {
        return `00:00`;
      } else {
        date.setMinutes(date.getMinutes() + 15);
        return `${date.getHours()}:${date.getMinutes()}`;
      }
    } else {
      return `00:00`;
    }

  }

}

